<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <WalletTabs></WalletTabs>
      <section ref="content" id="content" class="section subnav no-vpadding">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <div class="relative has-text-centered">
            <!-- Ghana -->
            <p v-if="user.countryID != 13" class="has-text-centered">{{ $t("NoProvidersAvailable") }}</p>
            <!-- Else -->
            <template v-else>
                <div ref="step1" class="absolute full-width">
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <a @click="topupWallet()" class="button is-primary is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-money"></i>
                                </span>
                                <span>{{ $t("SendToWallet") }}</span>
                            </a>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <a @click="topupTag()" class="button is-info is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-tag"></i>
                                </span>
                                <span>{{ $t("SendToTag") }}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div ref="topupWallet" class="absolute full-width is-hidden">
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <div class="field">
                                <label class="label">{{ $t("Network") }}</label>
                                <div class="control has-icons-left">
                                    <div class="select is-fullwidth">
                                        <div class="select is-fullwidth">
                                            <select ref="network" v-model="network" required>
                                                <option disabled value="disabled">{{ $t("Network")}}</option>
                                                <option v-for="network in networks" :key="network.id" :value="network.id">{{ network.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="icon is-small is-left">
                                        <i class="fa fa-globe"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-half">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <div class="select is-fullwidth">
                                        <select ref="callingCode" v-model="callingCode" required disabled>
                                            <option disabled value="disabled">{{ $t("Country")}}</option>
                                            <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="icon is-small is-left">
                                    <i class="fa fa-globe"></i>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half">
                            <div class="field">
                                <div class="control has-icons-left has-icons-right">
                                    <input ref="mobile" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="mobile" required disabled>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-phone"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="network == 'vodafone'" class="columns is-mobile is-centered">
                        <div class="column is-full">
                            <div class="column is-full">
                                <div class="field">
                                    <div class="control has-icons-left">
                                        <input ref="voucher" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" type="number" v-model="voucher" :placeholder="$t('Voucher')" autocomplete="off" required min="0">
                                        <span class="icon is-small is-left">
                                            <i class="fa fa-key"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <div class="field">
                                <label class="label">{{ $t("Amount") }}</label>
                                <div class="control has-icons-left">
                                    <input ref="amount" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="number" :placeholder="$t('Amount')" required :step="minTransfer" v-model.number="amount" :min="minTransfer">
                                    <span v-html="user.wallet.currency.symbol" class="icon is-small is-left"></span>
                                </div>
                            </div>
                            <div>{{ $t("MinimumTransferBody", [this.formatCurrency(this.minimumTransfer(user.wallet.currency), user.wallet.currency)]) }}</div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-half has-text-centered">
                            <a @click="send()" class="button is-primary is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-exchange"></i>
                                </span>
                                <span>{{ $t("Send") }}</span>
                            </a>
                        </div>
                        <div class="column is-half has-text-centered">
                            <a @click="back()" class="button is-info is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-arrow-left"></i>
                                </span>
                                <span>{{ $t("Back") }}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div ref="topupTag" class="absolute full-width is-hidden">
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <div class="field">
                                <label class="label">{{ $t("Network") }}</label>
                                <div class="control has-icons-left">
                                    <div class="select is-fullwidth">
                                        <div class="select is-fullwidth">
                                            <select ref="network2" v-model="network" required>
                                                <option disabled value="disabled">{{ $t("Network")}}</option>
                                                <option v-for="network in networks" :key="network.id" :value="network.id">{{ network.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="icon is-small is-left">
                                        <i class="fa fa-globe"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-half">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <div class="select is-fullwidth">
                                        <select ref="callingCode2" v-model="callingCode" required disabled>
                                            <option disabled value="disabled">{{ $t("Country")}}</option>
                                            <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="icon is-small is-left">
                                    <i class="fa fa-globe"></i>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half">
                            <div class="field">
                                <div class="control has-icons-left has-icons-right">
                                    <input ref="mobile2" class="input no-spinner" type="number" v-model="mobile" :placeholder="$t('Mobile')" required disabled>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-phone"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="network == 'vodafone'" class="columns is-mobile is-centered">
                        <div class="column is-full">
                            <div class="column is-full">
                                <div class="field">
                                    <div class="control has-icons-left">
                                        <input ref="voucher2" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" type="number" v-model="voucher" :placeholder="$t('Voucher')" autocomplete="off" required min="0">
                                        <span class="icon is-small is-left">
                                            <i class="fa fa-key"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select ref="nfcid" v-model="nfcid" required>
                                        <option disabled value="disabled">{{ $t("TagID")}}</option>
                                        <option v-for="tag in household.tags" :key="tag.nfcid" :value="tag.nfcid">{{ tag.nfcid }}</option>
                                    </select>
                                </div>
                                <div class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-full has-text-centered">
                            <div class="field">
                                <label class="label">{{ $t("Amount") }}</label>
                                <div class="control has-icons-left">
                                    <input ref="amount2" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="number" :placeholder="$t('Amount')" required :step="minTransfer" v-model.number="amount" :min="minTransfer">
                                    <span v-html="user.wallet.currency.symbol" class="icon is-small is-left"></span>
                                </div>
                            </div>
                            <div>{{ $t("MinimumTransferBody", [this.formatCurrency(this.minimumTransfer(user.wallet.currency), user.wallet.currency)]) }}</div>
                        </div>
                    </div>
                    <div class="columns is-mobile is-centered">
                        <div class="column is-half has-text-centered">
                            <a @click="send()" class="button is-primary is-fullwidth" :disabled="loading">
                                <span class="icon">
                                    <i class="fa fa-exchange"></i>
                                </span>
                                <span>{{ $t("Send") }}</span>
                            </a>
                        </div>
                        <div class="column is-half has-text-centered">
                            <a @click="back()" class="button is-info is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-arrow-left"></i>
                                </span>
                                <span>{{ $t("Back") }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </template>
          </div>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import WalletTabs from "@/components/WalletTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";
import axios from "axios";

export default {
  name: "Wallet",
  components: {
    Header,
    Modal,
    WalletTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  async mounted()
  {
    this.minTransfer = this.minimumTransfer(this.user.wallet.currency);
    this.callingCode = this.user.callingCode;
    this.mobile = this.user.mobile;

    if(this.user.householdID)
    {
        const response = await this.$http.get(`/Household`);
        this.household = response.data.household;
        
    }
  },
  computed: {
    country: function()
    {
        for(const country of this.countries)
        {
            if(country.countryId == this.user.countryID)
            {
                return country.name;
            }
        }

        return "";
    }
  },
  data () {
      return {
          household: {tags:[]},
          amount: null,
          callingCode: null,
          mobile: null,
          nfcid: null,
          step: "topupWallet",
          minTransfer: 0,
          voucher: null,
          network: "disabled",
          networks:
          [
              {id: "mtn", name: "MTN"},
              {id: "vodafone", name: "Vodafone"},
              {id: "tigo", name: "Tigo"},
              {id: "airtel", name: "Airtel"}
          ],
          phoneEnabled: false,
          modal: {
              title: null,
              body: null,
              centerBody: true,
              className: "",
              buttons:
              [
                {id: 0, title: this.$t("OK"), className: "is-primary", click: () => this.$router.push("/wallet/pending")},
              ]
          }
      }
  },
  methods:
  {
      send: async function()
      {
        const payload =
        {
            Currency: this.user.wallet.currency.code
        };

        if(this.step == "topupWallet")
        {
            if (this.$refs.network.selectedIndex == 0) {
                this.$refs.network.selectedIndex = -1;
            }

            if(!this.$refs.network.checkValidity())
            {
                this.$refs.network.reportValidity();
                return;
            }

            if (this.$refs.callingCode.selectedIndex == 0) {
                this.$refs.callingCode.selectedIndex = -1;
            }

            if(!this.$refs.callingCode.checkValidity())
            {
                this.$refs.callingCode.reportValidity();
                return;
            }

            if(!this.$refs.mobile.checkValidity())
            {
                this.$refs.mobile.reportValidity();
                return;
            }

            if(this.network == "vodafone")
            {
                
                if(!this.$refs.voucher.checkValidity())
                {
                    this.$refs.voucher.reportValidity();
                    return;
                }
            }

            if(!this.$refs.amount.checkValidity())
            {
                this.$refs.amount.reportValidity();
                return;
            }

            payload.Mobile = this.user.callingCode + this.user.mobile;
        }

        else
        {
            if (this.$refs.network2.selectedIndex == 0) {
                this.$refs.network2.selectedIndex = -1;
            }

            if(!this.$refs.network2.checkValidity())
            {
                this.$refs.network2.reportValidity();
                return;
            }

            if (this.$refs.callingCode2.selectedIndex == 0) {
                this.$refs.callingCode2.selectedIndex = -1;
            }

            if(!this.$refs.callingCode2.checkValidity())
            {
                this.$refs.callingCode2.reportValidity();
                return;
            }

            if(this.network == "vodafone" && !this.$refs.voucher2.checkValidity())
            {
                this.$refs.voucher2.reportValidity();
                return;
            }

            if(!this.$refs.mobile2.checkValidity())
            {
                this.$refs.mobile2.reportValidity();
                return;
            }

            if(!this.$refs.nfcid.checkValidity())
            {
                this.$refs.nfcid.reportValidity();
                return;
            }

            if(!this.$refs.amount2.checkValidity())
            {
                this.$refs.amount2.reportValidity();
                return;
            }

            payload.NFCID = this.nfcid;
        }

        const response = await axios.post(`${process.env.VUE_APP_GATEWAY_URL}/uniwallet`,
        {
            Payload: payload,
            Mobile: this.callingCode + this.mobile,
            Amount: this.amount,
            Network: this.network,
            Voucher: this.voucher
        });

        this.modal.title = this.$t("CheckHandset");
        this.modal.body = this.$t("CheckHandsetBody");
        this.modal.className = "is-active";
      },
      back()
      {
            this.$refs.step1.classList.remove("is-hidden");
            this.$refs[this.step].classList.add("is-hidden");
      },
      topupWallet()
      {
            this.$refs.step1.classList.add("is-hidden");
            this.$refs.topupWallet.classList.add("is-hidden");
            this.step = "topupWallet";
      },
      topupTag()
      {
            this.$refs.step1.classList.add("is-hidden");
            this.$refs.topupTag.classList.add("is-hidden");
            this.step = "topupTag";
      }
  }
};
</script>
